"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Window_1 = require("./Window");
var Component_1 = require("./Component");
var LangUtils_1 = require("@twii/core/lib/LangUtils");
var WindowSettings_1 = require("./WindowSettings");
var WindowManager = /** @class */ (function (_super) {
    __extends(WindowManager, _super);
    function WindowManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._closeDisabled = false;
        _this.windows = [];
        _this._windowSettings = new WindowSettings_1.WindowSettings();
        return _this;
    }
    Object.defineProperty(WindowManager.prototype, "type", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowManager.prototype, "windowSettings", {
        get: function () {
            return this._windowSettings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowManager.prototype, "first", {
        get: function () {
            return this.windowCount > 0 ? this.windows[0] : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowManager.prototype, "last", {
        get: function () {
            return this.windowCount > 0 ? this.windows[this.windows.length - 1] : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowManager.prototype, "windowCount", {
        get: function () {
            return this.windows ? this.windows.length : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowManager.prototype, "isWindowManager", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    WindowManager.prototype.add = function (win, opts) {
        if (win) {
            if (win.parent !== this) {
                win.removeFromParent();
                win.parent = this;
            }
            else {
                var itemIdx = this.windows.indexOf(win);
                this.windows.splice(itemIdx, 1);
            }
            this.windows.push(win);
        }
    };
    WindowManager.prototype.addNew = function (opts) {
        if (this.addApp) {
            var addApp = LangUtils_1.isFunction(this.addApp) ? this.addApp() : this.addApp;
            if (opts) {
                addApp = Object.assign({}, addApp, opts);
            }
            return this.open(addApp);
        }
        return Promise.resolve();
    };
    WindowManager.prototype.insertAt = function (item, index) {
        if (item && index >= 0 && index < this.windows.length) {
            var refStackItem = this.windows[index];
            var insertIdx = -1;
            if (item.parent !== this) {
                item.removeFromParent();
                item.parent = this;
                insertIdx = index;
            }
            else {
                var itemIdx = this.windows.indexOf(item);
                if (itemIdx >= 0 && itemIdx !== index) {
                    this.windows.splice(itemIdx, 1);
                    insertIdx = this.windows.indexOf(refStackItem);
                }
            }
            if (insertIdx >= 0) {
                this.windows.splice(insertIdx, 0, item);
            }
        }
        else {
            this.add(item);
        }
    };
    WindowManager.prototype.insertBefore = function (item, refItem) {
        if (!refItem) {
            this.add(item);
        }
        else if (item) {
            this.insertAt(item, this.windows.indexOf(refItem));
        }
    };
    WindowManager.prototype.replace = function (newItem, oldItem) {
        if (newItem && oldItem && oldItem.parent === this) {
            this.insertBefore(newItem, oldItem);
            oldItem.removeFromParent();
        }
    };
    WindowManager.prototype._windowDropped = function (win) {
        // does nothing by default
    };
    WindowManager.prototype.dropWindow = function (refWindow) {
        var drag = this.dashboard ? this.dashboard.drag : undefined;
        if (drag) {
            var win = drag;
            if (refWindow) {
                if (drag.parent === this) {
                    var dragIdx = this.windows.indexOf(win);
                    var refIdx = this.windows.indexOf(refWindow);
                    this.insertAt(win, dragIdx > refIdx ? refIdx : refIdx + 1);
                }
                else {
                    this.insertBefore(win, refWindow);
                }
            }
            else {
                this.add(win);
            }
            this._windowDropped(win);
            this.dashboard.clearDrag();
        }
    };
    WindowManager.prototype.open = function (request) {
        var win;
        if (request && request.replace && request.name) {
            var db = this.dashboard;
            win = db.findFirst(function (w) {
                return w.type === "window" ? w.name === request.name : false;
            });
        }
        if (!win) {
            win = new Window_1.Window();
            if (request) {
                win.name = request.name;
                win.setPath(request.path);
                win.setParams(request.params);
                win.setQuery(request.query);
                if (request.title) {
                    win.setTitle(request.title);
                }
                if (request.transient !== undefined) {
                    win.setTransient(request.transient);
                }
            }
            this.add(win, request);
        }
        else {
            win.load(request);
        }
        return Promise.resolve(win);
    };
    Object.defineProperty(WindowManager.prototype, "closeDisabled", {
        get: function () {
            return this._closeDisabled;
        },
        set: function (value) {
            this.setCloseDisabled(value);
        },
        enumerable: true,
        configurable: true
    });
    WindowManager.prototype.setCloseDisabled = function (closeDisabled) {
        this._closeDisabled = closeDisabled;
    };
    WindowManager.prototype._visitChildren = function (callback) {
        this.windows.forEach(function (w) { return w.visit(callback); });
    };
    WindowManager.prototype._findFirstChild = function (predicate) {
        var r;
        this.windows.some(function (w) {
            r = w.findFirst(predicate);
            return r ? true : false;
        });
        return r;
    };
    WindowManager.prototype._findAllChildren = function (predicate) {
        var r = [];
        var wr;
        this.windows.forEach(function (w) {
            wr = w.findAll(predicate);
            if (wr && wr.length > 0) {
                r = r.concat(wr);
            }
        });
        return r;
    };
    WindowManager.prototype.remove = function (node) {
        var idx = this.windows.indexOf(node);
        if (idx >= 0) {
            var w = this.windows[idx];
            w.parent = undefined;
            this.windows.splice(idx, 1);
            if (this.windows.length === 0) {
                this.removeFromParent();
            }
        }
    };
    WindowManager.prototype.close = function () {
        if (!this.closeDisabled) {
            while (this.windowCount > 0) {
                this.windows[0].close();
            }
            this.removeFromParent();
        }
    };
    __decorate([
        mobx_1.observable
    ], WindowManager.prototype, "_closeDisabled", void 0);
    __decorate([
        mobx_1.observable
    ], WindowManager.prototype, "windows", void 0);
    __decorate([
        mobx_1.observable
    ], WindowManager.prototype, "_windowSettings", void 0);
    __decorate([
        mobx_1.computed
    ], WindowManager.prototype, "windowSettings", null);
    __decorate([
        mobx_1.computed
    ], WindowManager.prototype, "first", null);
    __decorate([
        mobx_1.computed
    ], WindowManager.prototype, "last", null);
    __decorate([
        mobx_1.computed
    ], WindowManager.prototype, "windowCount", null);
    __decorate([
        mobx_1.action
    ], WindowManager.prototype, "add", null);
    __decorate([
        mobx_1.action
    ], WindowManager.prototype, "addNew", null);
    __decorate([
        mobx_1.action
    ], WindowManager.prototype, "insertAt", null);
    __decorate([
        mobx_1.action
    ], WindowManager.prototype, "insertBefore", null);
    __decorate([
        mobx_1.action
    ], WindowManager.prototype, "replace", null);
    __decorate([
        mobx_1.action
    ], WindowManager.prototype, "dropWindow", null);
    __decorate([
        mobx_1.action
    ], WindowManager.prototype, "open", null);
    __decorate([
        mobx_1.computed
    ], WindowManager.prototype, "closeDisabled", null);
    __decorate([
        mobx_1.action
    ], WindowManager.prototype, "setCloseDisabled", null);
    __decorate([
        mobx_1.action
    ], WindowManager.prototype, "remove", null);
    __decorate([
        mobx_1.action
    ], WindowManager.prototype, "close", null);
    return WindowManager;
}(Component_1.Component));
exports.WindowManager = WindowManager;
